import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'transaction-completed',
    templateUrl: './transaction-completed.component.html',
    styleUrls: ['./transaction-completed.component.scss']
  })
  export class TransactionCompletedComponent implements OnInit {

    constructor(private router: Router, private route: ActivatedRoute){}

    @Input() prepaidAmount;
    @Input() isPrepaidTransaction;
    @Input() transactionCurrency;

    ngOnInit(): void {
      this.route.queryParams.subscribe(params => {
        if (params.amount) {
          this.prepaidAmount = params.amount;
        }
      });

      this.isPrepaidTransaction = true;
      this.transactionCurrency = "zł";
    }

    public onGoToMyOrders(){
        this.router.navigate(['/my-account/my-orders']);
    }

  }
